export class PhoneValidationMessages {
    public RequiredMessage: string;
    public MaxLengthMessage: string;
    public InvalidInputMessage: string;
}
